<template>
<v-dialog persistent v-model="show" max-width="300">
  <v-card>
    <v-layout class="animated fadeIn delay-0.5s">
       <v-flex>
        <v-autocomplete
          class="px-2 mt-3"
          v-model="selected"
          :search-input.sync="search"
          no-filter
          :items="items"
          :loading="isLoading"
          color="#099AB1"
          hide-selected
          item-text="description"
          placeholder="Buscar..."
          prepend-icon="search"
          return-object
        >
          <template v-slot:item="data">
            <v-list-tile-avatar class="pl-2">
              <div
                v-lazy-container="{ error: 'https://s3.amazonaws.com/konselior/blankwhats.jpg', loading: 'https://s3.amazonaws.com/konselior/blankwhats.jpg' }"
              >
                <img
                  class="avatarImg"
                  :data-src="data.item.celular.whatsapp.picture"
                  v-if="data.item.celular && data.item.celular.whatsapp"
                />
                <img
                  class="avatarImg"
                  :data-src="'https://s3.amazonaws.com/konselior/blankwhats.jpg'"
                  v-if="!data.item.celular || !data.item.celular.whatsapp"
                />
              </div>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                v-html="`${data.item.nome} ${data.item.sobrenome}` "
                class="alignSelect"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-html="`Vendedor: ${data.item.seller}`"
              ></v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </v-autocomplete>
      </v-flex>
    </v-layout>
    <v-card-text v-if="selected">
        <v-layout>
            <v-flex>
                <strong>Contato:</strong> {{selected.nome}} {{selected.sobrenome}}
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
               <strong>Vendedor:</strong> {{selected.seller}}
            </v-flex>
        </v-layout>
    </v-card-text>
    <v-card-actions class="animated fadeIn delay-0.5s">
      <v-spacer></v-spacer>

      <v-btn
        round
        small
        outline
        flat="flat"
        class="text-lowercase"
        @click.stop="show=false; selected=''"
      >fechar</v-btn>
    </v-card-actions>
  </v-card>
  </v-dialog>
</template>

<script>
import format from 'date-fns/format';
import { APIService } from '@/resources/campanha.js';
import { mapState, mapActions } from 'vuex';
import Fuse from 'fuse.js';


const api = new APIService();

export default {
  data() {
    return {
      matches: [],
      selected: null,
      fuse: null,
      search: '',
      lastLetter: null,
      isLoading: false,
    };
  },
  computed: {
    items() {
      const people = this.matches.map((entry) => {
        const description = `${entry.nome ? entry.nome : ''} ${
          entry.sobrenome ? entry.sobrenome : ''
        }`;
        return Object.assign({}, entry, { description });
      });

      return people;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    ...mapState(['agendaMarca']),
  },
  watch: {
    search(a) {
      if (this.fuse && a) {
        this.matches = this.fuse.search(a.trim());
      }
    },
  },
  methods: {

  },
  props: {
    value: Boolean,
  },
  mounted() {
    const options = {
      shouldSort: true,
      threshold: 0.6,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ['nome', 'sobrenome', 'celular', 'cpf'],
    };
    this.fuse = new Fuse(this.agendaMarca, options);
  },
};
</script>

<style scoped>
.v-card {
  box-shadow: none;
  border-radius: 10px;
}

.theme--light.v-sheet {
  border: 1px solid #e0e0e0;
}
</style>

<style>
.v-input__append-outer .v-icon, .v-input__prepend-outer .v-icon{
    font-size: 18px !important;
}
</style>
